// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchCardEmpty_container__gakOh"};